import { motion, useAnimation } from 'framer-motion'
import { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'

const variants = {
  visible: { y: 0, opacity: 1 },
  hidden: { y: '50px', opacity: 0 },
}

export const FadeInWhenVisible: React.FC<{ wrapCenter?: boolean }> = ({
  children,
  wrapCenter,
}) => {
  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start('visible')
    }
  }, [controls, inView])

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      transition={{ duration: 1.25 }}
      variants={variants}
      style={
        wrapCenter
          ? { width: '100%', display: 'flex', justifyContent: 'center' }
          : {}
      }
    >
      {children}
    </motion.div>
  )
}
